import React from 'react';
import type PlanSettingsScheduleType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/scheduling/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - scheduling page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsScheduling = lazyForPaint<typeof PlanSettingsScheduleType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-scheduling", jiraSpaEntry: "async-plan-settings-scheduling" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/scheduling'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsScheduling = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsScheduling}
		pageId="plan-settings-scheduling"
		shouldShowSpinner={!fg('plan_settings_refresh')}
	/>
);

export default AsyncPlanSettingsScheduling;
